export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const TIPO_CONFIG = {
  entrada: {
    label: 'Entrada',
    color: '#1B4332',
    bg: '#F0FDF4',
    sign: '+',
  },
  saida: {
    label: 'Saida',
    color: '#DC2626',
    bg: '#FEF2F2',
    sign: '-',
  },
  sangria: {
    label: 'Sangria',
    color: '#B45309',
    bg: '#FFFBEB',
    sign: '-',
  },
  suprimento: {
    label: 'Suprimento',
    color: '#0369A1',
    bg: '#F0F9FF',
    sign: '+',
  },
};

export const FORMA_CONFIG = {
  dinheiro: { label: 'Dinheiro' },
  debito: { label: 'Debito' },
  credito: { label: 'Credito' },
  pix: { label: 'PIX' },
  pix_online: { label: 'Pix – Vendas Online' },
  cartao_online: { label: 'Cartão – Vendas Online' },
  outro: { label: 'Outro' },
};

export const ORIGEM_CONFIG = {
  estorno: { label: 'Estorno', color: '#B91C1C', bg: '#FEF2F2' },
  caixa_fisico: { label: 'Caixa fisico', color: '#1B4332', bg: '#F0FDF4' },
  caixinha_cora: { label: 'Caixinha Cora', color: '#7C3AED', bg: '#F5F3FF' },
  aporte_pessoal: { label: 'Aporte pessoal', color: '#B45309', bg: '#FFFBEB' },
  outro: { label: 'Outro', color: '#71717A', bg: '#F4F4F5' },
};

export const STATUS_CAIXA = {
  nao_aberto: { label: 'Nao aberto', color: '#A1A1AA', bg: '#F4F4F5' },
  aberto: { label: 'Aberto', color: '#1B4332', bg: '#F0FDF4' },
  fechado: { label: 'Fechado', color: '#71717A', bg: '#F4F4F5' },
};

export const formatCurrency = (value) => {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value || 0);
};

export const formatDateBR = (dateStr) => {
  const d = new Date(dateStr + 'T12:00:00');
  return d.toLocaleDateString('pt-BR', { weekday: 'long', day: 'numeric', month: 'long' });
};

export const isToday = (dateStr) => {
  return dateStr === new Date().toISOString().split('T')[0];
};

export const formatTime = (isoStr) => {
  if (!isoStr) return '';
  try {
    const d = new Date(isoStr);
    return d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
  } catch { return ''; }
};

export const BANDEIRAS = ['Visa', 'MasterCard', 'ELO', 'Amex', 'Hipercard', 'Outra'];
export const FORMAS_CARTAO = ['credito', 'debito', 'cartao_online'];
